import React, { FC, useCallback, useMemo, useState } from 'react';

import { SnackbarContext } from '../context/SnackbarContext';
import { ALERT_SEVERITY } from '../enum/snackbarProps';
import Snackbar from '../Snackbar';

const SnackbarProvider: FC = (props) => {
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState(ALERT_SEVERITY.SUCCESS);
  const [message, setMessage] = useState('');
  const add = useCallback(
    (addSeverity: ALERT_SEVERITY, addMessage: string) => {
      setSeverity(addSeverity);
      setMessage(addMessage);
      setOpen(true);
    },
    [setSeverity, setMessage, setOpen],
  );
  const remove = useCallback(() => {
    setOpen(false);
  }, [setOpen]);
  const value = useMemo(() => ({ open, severity, message, add, remove }), [open, severity, message, add, remove]);

  return (
    <SnackbarContext.Provider value={value}>
      <Snackbar />
      {props.children}
    </SnackbarContext.Provider>
  );
};

export default SnackbarProvider;
